const Index = () => import("./index.vue");
const CreatePage = () => import("./_pages/create.vue");
const ViewPage = () => import("./_pages/view.vue");

export default [
  {
    path: "/store-sections",
    component: Index,
  },
  {
    path: "/new-store-section",
    component: CreatePage,
  },
  {
    path: "/store-section/:id",
    component: ViewPage,
  },
];
